import { DEPRECATED_COMPONENTS_DATA } from './constants';

const getDeprecationData = (compType: string) => {
  return compType in DEPRECATED_COMPONENTS_DATA
    ? DEPRECATED_COMPONENTS_DATA[
        compType as keyof typeof DEPRECATED_COMPONENTS_DATA
      ]
    : null;
};

export { getDeprecationData };
